// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3HdRH","col":"Table_col__lUkld","fulfillmentStatus":"Table_fulfillmentStatus__3W569","emailCol":"Table_emailCol__1rv9j"};